import * as React from "react";
import PropTypes from "prop-types";

const harveyBalls = {
  zero: (color1, color2 = "white") => <circle cx="50" cy="50" r="50" fill={color1} stroke={color2} />,
  quarter: (color1, color2 = "white") => (
    <>
      <circle cx="50" cy="50" r="50" fill={color1} />
      <path
        d="M50,50
    L50,1
    A50,50 0 0 1 99,50
    L50,50 "
        fill={color2}
        stroke={color1}
      />
    </>
  ),
  half: (color1, color2 = "white") => (
    <>
      <circle cx="50" cy="50" r="50" fill={color1} />
      <path
        d="M50,50
    L50,1
    A49,49 0 0 1 50,99
    L50,50 "
        fill={color2}
        stroke={color1}
      />
    </>
  ),
  threeQuarters: (color1, color2 = "white") => (
    <>
      <circle cx="50" cy="50" r="50" fill={color1} />
      <path
        d="M50,50
    L50,1
    A49,49 0 0 1 50,99
    L50,50 "
        fill={color2}
      />
      <path
        d="M50,50
    L50,99
    A49,49 0 0 1 1,50
    L50,50 "
        fill={color2}
      />
    </>
  ),
  full: (color1, color2 = "white") => <circle cx="50" cy="50" r="49" fill={color2} stroke={color1} />,
  quarterInverted: (color1, color2 = "white") => (
    <>
      <circle cx="50" cy="50" r="49" fill={color2} stroke={color1} />
      <path
        d="M50,50
    L50,1
    A50,50 0 0 1 100,50
    L50,50 "
        fill={color1}
        stroke={color1}
      />
    </>
  ),
  halfInverted: (color1, color2 = "white") => (
    <>
      <circle cx="50" cy="50" r="49" fill={color2} stroke={color1} />
      <path
        d="M50,50
    L50,1
    A49,49 0 0 1 50,99
    L50,50 "
        fill={color1}
        stroke={color1}
      />
    </>
  ),
  threeQuartersInverted: (color1, color2 = "white") => (
    <>
      <circle cx="50" cy="50" r="49" fill={color2} stroke={color1} />
      <path
        d="M50,50
    L50,1
    A49,49 0 0 1 50,99
    L50,50 "
        fill={color1}
      />
      <path
        d="M50,50
    L50,99
    A49,49 0 0 1 1,50
    L50,50 "
        fill={color1}
      />
    </>
  ),
};

const HarveyBall = ({ type, color, color2, size, margin }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" style={{ marginTop: margin }}>
      {harveyBalls[type] ? harveyBalls[type](color ?? "black", color2) : harveyBalls.quarter(color ?? "black", color2)}
    </svg>
  );
};

HarveyBall.propTypes = {
  type: PropTypes.string,
  color: PropTypes.string,
  color2: PropTypes.string,
  size: PropTypes.number,
  margin: PropTypes.number,
};

export default HarveyBall;
